export const FEES_TYPE_OPTIONS = [
  { value: "Login Bill", label: "Login Bill" },
  { value: "Completed Bill", label: "Completed Bill" },
  { value: "Cash Bill", label: "Cash Bill" },
];

export const SINGLE_BILL_DETAIL_OPTIONS = [
  { value: "Common Bill", label: "Common Bill" },
  { value: "Location Wise Bill", label: "Location Wise Bill" },
];

export const isMergeBillType = (billTypes: any[], billTypeId: any) => {
  if (!billTypeId || !billTypes || !billTypes.length) {
    return false;
  }
  const billType = billTypes.find((item: any) => String(item.id) === String(billTypeId));
  return billType && String(billType.name).trim().toLowerCase() === "merge bill";
};

export const isSingleBillType = (billTypes: any[], billTypeId: any) => {
  if (!billTypeId || !billTypes || !billTypes.length) {
    return false;
  }
  const billType = billTypes.find((item: any) => String(item.id) === String(billTypeId));
  return billType && String(billType.name).trim().toLowerCase() === "single bill";
};

export const isValidEmailField = (email: string) => {
  if (!email || !email.trim()) {
    return true;
  }
  const parts = email
    .split(/[;,]/)
    .map((part) => part.trim())
    .filter(Boolean);
  return parts.every((part) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(part));
};

export const LOGIN_BILLING_FEE_FIELDS = ["login_fees", "mutation"] as const;

export const BANK_BRANCH_FEE_FIELDS = ["vetting_fees", "login_fees", "mutation"] as const;

export const isValidAmountInput = (value: string) => {
  if (value === "" || value === null || value === undefined) {
    return true;
  }
  return /^\d+$/.test(value);
};

export const normalizeFeeAmountDisplay = (value: string | number | null | undefined) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }
  const amount = String(value).trim();
  if (/^\d+$/.test(amount)) {
    return amount;
  }
  if (/^\d+\.\d+$/.test(amount) && Number(amount) === Math.floor(Number(amount))) {
    return String(Math.floor(Number(amount)));
  }
  return amount;
};

export const isZeroAmount = (value: string | number) => {
  if (value === "" || value === null || value === undefined) {
    return false;
  }
  const amount = Number(value);
  return !Number.isNaN(amount) && amount === 0;
};

export const canAcceptFeeAmountInput = (value: string) => {
  if (!isValidAmountInput(value)) {
    return false;
  }
  if (value !== "" && isZeroAmount(value)) {
    return false;
  }
  return true;
};

export const validateFeeAmount = (
  value: string | number | null | undefined,
  label: string,
  required = false
) => {
  const amount = String(value ?? "").trim();
  if (amount === "") {
    return required ? `${label} is required` : "";
  }
  if (!isValidAmountInput(amount)) {
    return `${label} must be a whole number`;
  }
  if (isZeroAmount(amount)) {
    return `${label} cannot be 0`;
  }
  return "";
};

export const validateLoginBillingFields = (
  state: any,
  billTypes: any[] = state.billTypes || [],
  loginFeesLabel = "Login Fees"
) => {
  if (!state.bill_type_id) {
    return "Bill Type is required";
  }

  if (!state.fees_type) {
    return "Fees Type is required";
  }

  if (!isValidEmailField(state.bill_receive_to_mail || "")) {
    return "Invalid Bill Send To";
  }

  if (!isValidEmailField(state.cc_mail || "")) {
    return "Invalid CC Mail";
  }

  if (isMergeBillType(billTypes, state.bill_type_id) && !state.lh_branch) {
    return "LH Branch is required when Bill Type is Merge Bill";
  }

  if (isSingleBillType(billTypes, state.bill_type_id) && !state.single_bill_detail) {
    return "Common Bill & Location Wise Bill is required when Bill Type is Single Bill";
  }

  const loginFeesError = validateFeeAmount(state.login_fees, loginFeesLabel, true);
  if (loginFeesError) {
    return loginFeesError;
  }

  const amountFields = [
    { key: "mutation", label: "Mutation Service Charge" },
  ];

  for (const field of amountFields) {
    const amountError = validateFeeAmount(state[field.key], field.label);
    if (amountError) {
      return amountError;
    }
  }

  return "";
};

export const validateBankBranchFeeFields = (branchdetail: any) => {
  const requiredFields = [
    { key: "vetting_fees", label: "Vetting Fees" },
    { key: "login_fees", label: "Legal Login Fees" },
  ];
  const optionalFields = [
    { key: "mutation", label: "Mutation Service Charge" },
  ];

  for (const field of requiredFields) {
    const amountError = validateFeeAmount(branchdetail[field.key], field.label, true);
    if (amountError) {
      return amountError;
    }
  }

  for (const field of optionalFields) {
    const amountError = validateFeeAmount(branchdetail[field.key], field.label);
    if (amountError) {
      return amountError;
    }
  }

  return "";
};

export const defaultLoginBillingState = {
  bill_type_id: "",
  single_bill_detail: "",
  login_fees: "",
  lh_branch: "",
  bill_receive_to_mail: "",
  cc_mail: "",
  // ec_service_charge: "",
  // cc_service_charge: "",
  mutation: "",
  fees_type: "",
  billTypes: [] as any[],
};

export const hasLoginBillingData = (state: any) => {
  return !!(
    state.bill_type_id ||
    state.single_bill_detail ||
    state.fees_type ||
    state.lh_branch ||
    state.bill_receive_to_mail ||
    state.cc_mail ||
    state.login_fees ||
    // state.ec_service_charge ||
    // state.cc_service_charge ||
    state.mutation
  );
};

export const mapBankBranchFeesToState = (fees: any, module: "legal" | "vetting") => ({
  bill_type_id: fees.bill_type_id || "",
  single_bill_detail: fees.single_bill_detail || "",
  fees_type: fees.fees_type || "",
  lh_branch: fees.lh_branch || "",
  bill_receive_to_mail: fees.bill_receive_to_mail || "",
  cc_mail: fees.cc_mail || "",
  // ec_service_charge: fees.ec_service_charge || "",
  // cc_service_charge: fees.cc_service_charge || "",
  mutation: normalizeFeeAmountDisplay(fees.mutation || ""),
  login_fees: normalizeFeeAmountDisplay(module === "legal" ? (fees.login_fees || "") : (fees.vetting_fees || "")),
});

export const stripLoginBillingServiceChargesFromPayload = (payload: any) => {
  const next = { ...payload };
  delete next.ec_service_charge;
  delete next.cc_service_charge;
  return next;
};
